import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToHashHandler() {
  const location = useLocation();

  useEffect(() => {
    // Only act when on home path and there's a hash
    if (location.pathname !== "/") return;
    if (!location.hash) return;

    const id = location.hash.replace("#", "");
    // Timeout allows elements to render
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 50);

    return () => clearTimeout(t);
  }, [location]);

  return null;
}
